import { displayFlashMessage, showLoadingMessage, hideLoadingMessage } from '../../util/methods';
import { loadSectionContent } from './product_page';

$(document).on('turbolinks:load', function() {
  if ($('.js-new-product-rating-form').length) initializeRatingsFormHandler();
});

export function initializeRatingsFormHandler() {
  $('.js-new-product-rating-form').on('submit', function(){
    showLoadingMessage('Submitting Rating...');
  }).on('ajax:success', function(e, data, status, xhr) {
    hideLoadingMessage();
    var parsedData = JSON.parse(data);

    if (parsedData['success']) {
      // refresh ratings list
      let $ratingsSection = $('#js-tab-content-ratings');
      loadSectionContent($ratingsSection, parsedData['ratings_path'], true);

      swal({
        title: "Thanks!",
        text: "We appreciate your rating!",
        icon: "success",
        buttons: {
          confirm: {
            text: "OK",
            value: true,
            visible: true,
            className: "",
            closeModal: true
          }
        }
      });
    } else {
      swal({
        title: "Uh Oh!",
        text: "Review failed. You are not currently allowed to review products on Superhive. Please contact support for more information.",
        icon: "warning",
        buttons: {
          confirm: {
            text: "OK",
            value: true,
            visible: true,
            className: "",
            closeModal: true
          }
        }
      });
    }
  }).on('ajax:error', function(e, xhr, status, error) {
    hideLoadingMessage();
    displayFlashMessage('danger', error);
  });
}
